import { render } from "./SliderImages.vue?vue&type=template&id=f2870f9c"
import script from "./SliderImages.vue?vue&type=script&lang=js"
export * from "./SliderImages.vue?vue&type=script&lang=js"

import "./SliderImages.vue?vue&type=style&index=0&id=f2870f9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__